import React from 'react';
import { Box } from '@mui/material';
import { Science as ExperimentIcon } from '@mui/icons-material';
import { DialogTitleWithClose } from '../../../common';

const DialogHeader = ({ experimentName, onClose, disableClose = false }) => {
  return (
    <DialogTitleWithClose
      title={
        <Box display="flex" alignItems="center" gap={1}>
          <ExperimentIcon />
          Edit Experiment: {experimentName}
        </Box>
      }
      onClose={onClose}
      disableClose={disableClose}
    />
  );
};

export default DialogHeader;
